import React from 'react';
import PropTypes from 'prop-types';
import isObject from 'lodash/isObject';
import { Select as RooSelect } from 'roo-ui/components';

const getLabel = (option) => (isObject(option) ? option.label : option);
const getValue = (option) => (isObject(option) ? option.value : option);

const Select = ({ value, options, ...rest }) => (
  <RooSelect value={value} mb={0} {...rest}>
    {options.map((option) => (
      <option key={getValue(option)} value={getValue(option)}>
        {getLabel(option)}
      </option>
    ))}
  </RooSelect>
);

Select.propTypes = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })),
};

Select.defaultProps = {
  value: '',
  options: [],
};

export default Select;
